import {MassCampaignChannelEnum} from '@/services/api-clients';

export function massCampaignChannelIconFilter(value: MassCampaignChannelEnum): string {
  switch (value) {
    case MassCampaignChannelEnum.Sms: return 'mdi-cellphone-message';
    case MassCampaignChannelEnum.Push: return 'mdi-bell-ring';
  }
}
